import { MenuCloseIcon } from './MenuCloseIcon';

/**
 * author: Michael Richins
 * id 04E66167-8706-4CEF-8748-63BDAAF0F19C
 * name menu-close
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/menu-close.svg
 * tags
 * - Navigation 
 */
export const HamburgerCloseIcon = MenuCloseIcon;
export default HamburgerCloseIcon